/* IMPORT */
import channel from './channel.js';
/* MAIN */
const lightness = (color) => {
    return channel(color, 'l');
};
/* EXPORT */
export default lightness;
